import { render, staticRenderFns } from "./EnterArticlePrice.vue?vue&type=template&id=0fde3f86"
import script from "./EnterArticlePrice.vue?vue&type=script&lang=js"
export * from "./EnterArticlePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports